module.exports = __webpack_public_path__ + "static/img/bg_mobile.0f67c43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg_mobile.png
// module id = yzre
// module chunks = 1